<template>
  <div></div>
</template>

<script>
export default {
  name: `Upgrade`
};
</script>
